import client from "../client";
import { extractErrorMessage } from "src/utils/misc";

export async function getTelematicsDetails(vehicleId) {
	try {
		const response = await client(`/v1/${vehicleId}`, {
			method: "GET",
			version: "Telematics",
		});
		return response;
	} catch (error) {
		console.error(error);
		throw error;
	}
}

export async function updateTelematicsDetails(
	identifier,
	provider,
	plateNumber,
	fuelType
) {
	try {
		const response = await client(`/v1/${identifier}`, {
			method: "PUT",
			version: "Telematics",
			data: { provider, plateNumber, fuelType },
		});
		return response;
	} catch (error) {
		console.error(error);
		extractErrorMessage(error);
		throw error;
	}
}
